import { useEffect, useRef, useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AvailabilitySearchBar from '@/components/feature/AvailabilitySearchBar';
import WhyChooseSection from './components/WhyChooseSection';
import AmenitiesSection from './components/AmenitiesSection';
import FeaturesSection from './components/FeaturesSection';
import OurVillasSection, { type VillaAvailabilityResult } from './components/OurVillasSection';
import MapSection from './components/MapSection';
import RulesSection from './components/RulesSection';
import Footer from './components/Footer';

export default function Home() {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const [availability, setAvailability] = useState<VillaAvailabilityResult | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.scroll-reveal');
    elements.forEach((el) => observerRef.current?.observe(el));

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return (
    <main>
      <Navbar />
      <HeroSection />
      <AvailabilitySearchBar
        onMultiResult={(available, checkIn, checkOut) =>
          setAvailability({ available, checkIn, checkOut })
        }
      />
      <WhyChooseSection />
      <AmenitiesSection />
      <FeaturesSection />
      <OurVillasSection availability={availability} />
      <MapSection />
      <RulesSection />
      <Footer />
    </main>
  );
}